import AbstractEntity from "../AbstractEntity";

export default class Entrepreneur extends AbstractEntity {
    _id;
    _authenticationId;
    _firstName;
    _lastName;
    _phone;
    _email;
    _companyId;

    getId() {
        return this._id;
    }

    getAuthenticationId() {
        return this._authenticationId;
    }

    getFirstName() {
        return this._firstName;
    }

    getLastName() {
        return this._lastName;
    }

    getPhone() {
        return this._phone;
    }

    getEmail() {
        return this._email;
    }

    getCompanyId() {
        return this._companyId;
    }

    getClassName() {
        return "entrepreneur";
    }
}